module.exports = __webpack_public_path__ + "img/xixi.bc52931a.gif";